import { i18n } from "@/plugins/i18n"

function limitations() {
  const items = [
    {
      text:
        i18n.global.t(
          "machines.rental.lease.settings.restrictionTypes.stopEngineAfter"
        ) +
        " " +
        i18n.global.t("common.units.second", 30),
      value: 1
    },
    {
      text:
        i18n.global.t(
          "machines.rental.lease.settings.restrictionTypes.stopEngineAfter"
        ) +
        " " +
        i18n.global.t("common.units.second", 300),
      value: 2
    },
    {
      text: i18n.global.t(
        "machines.rental.lease.settings.restrictionTypes.disableToolA"
      ),
      value: 4
    },
    {
      text: i18n.global.t(
        "machines.rental.lease.settings.restrictionTypes.reduceMovementSpeedToLvl3"
      ),
      value: 8
    },
    {
      text: i18n.global.t(
        "machines.rental.lease.settings.restrictionTypes.blinkLights"
      ),
      value: 16
    }
  ]
  return {
    items: items,
    getText: value => {
      return items.find(i => i.value == value)?.text
    }
  }
}

export default limitations
